import { IconAccessLog, IconLiveCaptions, IconManagerSIP, IconManagerSystem, IconMeetingSchedule, IconMonitor, IconPhonebook, IconRecording, IconRole, IconUser, IconWB } from "assets/sidebar"
import { FUNCTIONS } from "./roles"
import { IconHistoryPage } from "components/common/IconCommon"
import IconPackageManagement from "assets/sidebar/IconPackageManagement"
import IconMemberManagemet from "assets/sidebar/IconMemberManagemet"
import IconManageVersion from "assets/sidebar/IconManageVersion"
import IconMCUControl from "assets/sidebar/iconMCUControl"
import IconMCUSettings from "assets/sidebar/iconMCUSettings"
import IconMCUStatus from "assets/sidebar/iconMCUStatus"
import { checkFunctionHaveCode } from "store/user/functions"

export const ROUTE_PATH = {
    MANAGE_RECORD: {
        ROOT: 'manager-recordings',
        DETAIL_RECORD: 'manager-recordings/detail-record',
        SHARING_RECORD: 'manager-recordings/sharing-record'
    }
}

const MCU_PERMISSIONS = [
    FUNCTIONS.MCU_CONTROL_ROOM_MONITOR,
    FUNCTIONS.MCU_CONTROL_ROOM_VIEW,
    FUNCTIONS.MCU_CONTROL_SIP_ACCOUNT_VIEW,
];

const ROLE_PERMISSIONS = [
    FUNCTIONS.MANAGE_ROLE_VIEW,
    FUNCTIONS.MANAGE_FUNCTION_VIEW,
];

const SYSTEM_PERMISSIONS = [
    FUNCTIONS.MANAGE_SYSTEM_PARAMETER_VIEW,
    FUNCTIONS.MANAGE_UNIT_POSITION_VIEW,
    FUNCTIONS.MANAGE_UNIT_VIEW,
    FUNCTIONS.MANAGER_BRANDING_VIEW,
];

const MANAGEMENT_PERMISSIONS = [
    FUNCTIONS.MANAGE_USER_VIEW,
    ...ROLE_PERMISSIONS,
    ...SYSTEM_PERMISSIONS,
    FUNCTIONS.MANAGE_SYSTEM_LOG_VIEW,
    FUNCTIONS.MANAGE_SIP_ACCOUNT_VIEW,
    FUNCTIONS.MANAGE_MEETING_MONITOR_VIEW,
    FUNCTIONS.MANAGER_VERSION_VIEW,
];

export const getSidebarPath = (stateCurrent) => {
    const { functions } = stateCurrent;

    const hasAnyPermission = (permissions) => (
        permissions.some(permission => checkFunctionHaveCode(functions, permission))
    );

    const hasMcuPermission = hasAnyPermission(MCU_PERMISSIONS);
    const hasManagementPermission = hasAnyPermission(MANAGEMENT_PERMISSIONS);

    const SIDEBAR_PATH = [
        {
            code: null,
            labelKey: "sidebar.meetingCalendar",
            path: "manager-meeting",
            Icon: <IconMeetingSchedule />
        },
        {
            code: [FUNCTIONS.MANAGE_RECORDING_PERSONAL_VIEW],
            labelKey: "sidebar.recordings",
            path: "manager-recordings",
            Icon: <IconRecording />,
            requiredCodes: [FUNCTIONS.MANAGE_RECORDING_PERSONAL_VIEW]
        },
        {
            code: [FUNCTIONS.MANAGE_WHITEBOARD_VIEW],
            labelKey: "sidebar.whiteboard",
            path: "manager-whiteboard",
            Icon: <IconWB />,
            requiredCodes: [FUNCTIONS.MANAGE_WHITEBOARD_VIEW]
        },
        {
            code: [FUNCTIONS.MANAGE_SUBTITLE_PERSONAL_VIEW],
            labelKey: "sidebar.live-captions",
            path: "live-captions",
            Icon: <IconLiveCaptions />,
            requiredCodes: [FUNCTIONS.MANAGE_SUBTITLE_PERSONAL_VIEW]
        },
        {
            code: null,
            labelKey: "breadcrumbs.history",
            path: "history",
            Icon: <IconHistoryPage />
        },
        {
            code: null,
            labelKey: "sidebar.managerPackage",
            path: "service-package-management",
            Icon: <IconPackageManagement />
        },
        {
            code: null,
            labelKey: "sidebar.managerMember",
            path: "member-management",
            Icon: <IconMemberManagemet />
        },
        {
            code: [FUNCTIONS.MANAGE_CONTACTS_VIEW],
            labelKey: "sidebar.phonebook",
            path: "contacts",
            Icon: <IconPhonebook />,
            requiredCodes: [FUNCTIONS.MANAGE_CONTACTS_VIEW]
        },
        // {
        //     code: [FUNCTIONS.MANAGE_ORGANIZATION_VIEW],
        //     labelKey: "sidebar.organization",
        //     path: "organization",
        //     Icon: <IconOrganization />,
        //     requiredCodes: [FUNCTIONS.MANAGE_ORGANIZATION_VIEW]
        // },
        // MCU Section Divider - show if any MCU function has permission
        { path: !hasMcuPermission },
        {
            code: [FUNCTIONS.MCU_CONTROL_ROOM_MONITOR],
            labelKey: "sidebar.mcuStatus",
            path: "mcu-status",
            Icon: <IconMCUStatus />,
            requiredCodes: [FUNCTIONS.MCU_CONTROL_ROOM_MONITOR]
        },
        {
            code: [FUNCTIONS.MCU_CONTROL_ROOM_VIEW],
            labelKey: "sidebar.mcuControl",
            path: "mcu-control",
            Icon: <IconMCUControl />,
            requiredCodes: [FUNCTIONS.MCU_CONTROL_ROOM_VIEW]
        },
        {
            code: [FUNCTIONS.MCU_CONTROL_SIP_ACCOUNT_VIEW],
            labelKey: "sidebar.mcuSettings",
            path: "mcu-settings",
            Icon: <IconMCUSettings />,
            requiredCodes: [FUNCTIONS.MCU_CONTROL_SIP_ACCOUNT_VIEW]
        },
        // Management Section Divider - show if any management function has permission
        { path: !hasManagementPermission },
        {
            code: [FUNCTIONS.MANAGE_USER_VIEW],
            labelKey: "sidebar.users",
            path: "manager-users",
            Icon: <IconUser />,
            requiredCodes: [FUNCTIONS.MANAGE_USER_VIEW]
        },
        {
            code: ROLE_PERMISSIONS,
            labelKey: "sidebar.managerRoles",
            path: "manager-roles",
            Icon: <IconRole />,
            requiredCodes: ROLE_PERMISSIONS
        },
        {
            code: SYSTEM_PERMISSIONS,
            labelKey: "sidebar.managerSystem",
            path: "manager-systems",
            Icon: <IconManagerSystem />,
            requiredCodes: SYSTEM_PERMISSIONS
        },
        {
            code: [FUNCTIONS.MANAGE_SYSTEM_LOG_VIEW],
            labelKey: "sidebar.access",
            path: "access-log",
            Icon: <IconAccessLog />,
            requiredCodes: [FUNCTIONS.MANAGE_SYSTEM_LOG_VIEW]
        },
        {
            code: [FUNCTIONS.MANAGE_SIP_ACCOUNT_VIEW],
            labelKey: "sidebar.managerSip",
            path: "manager-user-sip",
            Icon: <IconManagerSIP />,
            requiredCodes: [FUNCTIONS.MANAGE_SIP_ACCOUNT_VIEW]
        },
        {
            code: [FUNCTIONS.MANAGE_MEETING_MONITOR_VIEW],
            labelKey: "sidebar.monitor",
            path: "meeting-monitor",
            Icon: <IconMonitor />,
            requiredCodes: [FUNCTIONS.MANAGE_MEETING_MONITOR_VIEW]
        },
        {
            code: [FUNCTIONS.MANAGER_VERSION_VIEW],
            labelKey: "sidebar.manager-version",
            path: "manager-version",
            Icon: <IconManageVersion />,
            requiredCodes: [FUNCTIONS.MANAGER_VERSION_VIEW]
        },
        {
            path: undefined
        }
    ];

    return SIDEBAR_PATH;
}
